import { z } from 'zod';

import { LocationId } from './Location';

export const EventId = z.string().brand('EventId');
export const Event = z.object({
  id: EventId,
  locationId: LocationId,
  name: z.string(),
  description: z.string(),
  eyeCatchURL: z.string().url(),
  bannerURL: z.string().url().optional(),
  date: z.string().datetime({ offset: true }),
  startTime: z.string().regex(/^\d{2}:\d{2}$/), //DB格納時はISO8601形式に変換する?
  endTime: z.string().regex(/^\d{2}:\d{2}$/),
  capacity: z.number(),
  attendees: z.number(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type EventType = z.infer<typeof Event>;
